// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_obj from "../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as CSS$Showside from "../../utils/CSS.bs.js";
import * as Category$Showside from "../../types/Category.bs.js";
import * as Scrollable$Showside from "../Scrollable.bs.js";
import * as NavMenu__Sections$Showside from "./NavMenu__Sections.bs.js";
import * as ConfigurationProvider$Showside from "../../context/ConfigurationProvider.bs.js";
function NavMenu__IndexContent(Props) {
  var category = Props.category;
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var scrollableContainerRef = React.useRef(null);
  var category$1 = React.useMemo(function () {
    var newrecord = Caml_obj.obj_dup(category);
    var rest = category.categoryType;
    var tmp;
    tmp = typeof rest === "number" || rest.TAG !== /* Index */3 ? rest : {
      TAG: /* Standard */1,
      _0: {
        firstCard: undefined,
        externalConnection: rest._0.externalConnection,
        children: Belt_Array.keep(config.categories, function (category) {
          return !Category$Showside.isIndexNode(category);
        }),
        loadMoreChildren: undefined,
        totalChildren: 0,
        link: undefined,
        products: [],
        taggedMedia: undefined,
        imageHotspots: undefined,
        imageWidth: undefined,
        imageHeight: undefined
      }
    };
    newrecord.categoryType = tmp;
    var match = category.userSelectedLayout;
    var tmp$1;
    if (typeof match === "number") {
      tmp$1 = /* NoLayout */0;
    } else {
      switch (match.TAG | 0) {
        case /* SubCategoriesGrid */2:
        case /* ProductGrid */3:
          tmp$1 = {
            TAG: /* SubCategoriesGrid */2,
            _0: match._0
          };
          break;
        default:
          tmp$1 = {
            TAG: /* SubCategoriesSlider */0,
            _0: match._0
          };
      }
    }
    newrecord.userSelectedLayout = tmp$1;
    newrecord.showTitle = true;
    newrecord.title = "";
    return newrecord;
  }, [category.id, config.lastModifiedAt]);
  var match$1 = category$1.userSelectedLayout;
  var tmp;
  var exit = 0;
  if (typeof match$1 === "number" || match$1.TAG !== /* SubCategoriesGrid */2) {
    exit = 1;
  } else {
    tmp = React.createElement(NavMenu__Sections$Showside.CLPSection.make, {
      index: 0,
      category: category$1,
      limitMaxRows: false,
      scrollableContainerRef: scrollableContainerRef,
      getForcedOpenLink: function (param) {
        return /* ForceNoCards */3;
      }
    });
  }
  if (exit === 1) {
    tmp = React.createElement(NavMenu__Sections$Showside.make, {
      allowQuickCategories: false,
      allCategories: config.categories,
      category: category$1,
      scrollableContainerRef: scrollableContainerRef
    });
  }
  return React.createElement(Scrollable$Showside.make, {
    restorationId: "nav-menu-sections-" + category$1.id + "",
    children: tmp,
    fwdRef: scrollableContainerRef,
    className: CSS$Showside.prefix("relative h-full no-scrollbar pb-20"),
    rememberScrollPosition: false
  });
}
NavMenu__IndexContent.displayName = "NavMenu__IndexContent";
var make = NavMenu__IndexContent;
export { make };
/* react Not a pure module */